import React from "react";

interface Scores {
  x: number;
  o: number;
  draws: number;
}

interface ScoreboardProps {
  scores: Scores;
}

export function Scoreboard({ scores }: ScoreboardProps) {
  return (
    <div
      className="fade-up delay-1 flex items-center gap-3 sm:gap-5"
      style={{ opacity: 0 }}
    >
      {/* X Score */}
      <div className="flex flex-col items-center min-w-[72px] sm:min-w-[88px]">
        <span
          className="text-[28px] sm:text-[36px] font-bold leading-none tracking-tight"
          style={{
            fontFamily: "var(--font-mono)",
            color: "var(--color-x)",
            textShadow: "0 0 16px var(--color-x-glow)",
          }}
        >
          {scores.x}
        </span>
        <span
          className="text-[11px] sm:text-xs font-semibold uppercase tracking-[0.2em] mt-1"
          style={{ color: "var(--color-x)", opacity: 0.7 }}
        >
          Player X
        </span>
      </div>

      {/* Divider */}
      <div
        className="h-10 w-px"
        style={{ background: "var(--color-grid-line)" }}
      />

      {/* Draws */}
      <div className="flex flex-col items-center min-w-[60px] sm:min-w-[72px]">
        <span
          className="text-[28px] sm:text-[36px] font-bold leading-none tracking-tight"
          style={{
            fontFamily: "var(--font-mono)",
            color: "var(--color-dim)",
          }}
        >
          {scores.draws}
        </span>
        <span
          className="text-[11px] sm:text-xs font-semibold uppercase tracking-[0.2em] mt-1"
          style={{ color: "var(--color-dim)", opacity: 0.7 }}
        >
          Draws
        </span>
      </div>

      {/* Divider */}
      <div
        className="h-10 w-px"
        style={{ background: "var(--color-grid-line)" }}
      />

      {/* O Score */}
      <div className="flex flex-col items-center min-w-[72px] sm:min-w-[88px]">
        <span
          className="text-[28px] sm:text-[36px] font-bold leading-none tracking-tight"
          style={{
            fontFamily: "var(--font-mono)",
            color: "var(--color-o)",
            textShadow: "0 0 16px var(--color-o-glow)",
          }}
        >
          {scores.o}
        </span>
        <span
          className="text-[11px] sm:text-xs font-semibold uppercase tracking-[0.2em] mt-1"
          style={{ color: "var(--color-o)", opacity: 0.7 }}
        >
          Player O
        </span>
      </div>
    </div>
  );
}
